module.exports = __webpack_public_path__ + "static/media/item_8_7_comp.c224ee39.png";